// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonCol } from "@ionic/react"


interface ResponsiveIonColProps {
  children?: React.ReactNode
}


const ResponsiveIonCol: React.FC<ResponsiveIonColProps> = ({children}) => {
  return (
    <IonCol sizeMd="8" sizeLg="6" sizeXl="4">{children}</IonCol>
  )
}


export {ResponsiveIonCol}